module.exports = __webpack_public_path__ + "img/5f444955f594b910427aa5199d11db08.png";